import React, { useEffect } from 'react';
import { Checkbox } from '@mantine/core';
import { useListState } from '@mantine/hooks';
import { useMapFilterContext } from '@/contexts/MapFilterContext';

const initialValues = [
  { label: 'Source Control', checked: true, key: 'Source control' },
  {
    label: 'Swales & Conveyance Channels',
    checked: true,
    key: 'Swales and conveyance channels overview',
  },
  { label: 'Infiltration', checked: true, key: 'Infiltration' },
  { label: 'Filtration', checked: true, key: 'Filtration' },
  { label: 'Retention & Detention', checked: true, key: 'Retention&Detention' },
  { label: 'Wetlands', checked: true, key: 'Wetlands' },
  { label: 'Inlets, Outlets, Control', checked: true, key: 'Inlets,Outlets,Control' },
  { label: 'Other', checked: true, key: 'Unknown' },
];

export function SudsFilter() {
  const { setSudsTypeFilter } = useMapFilterContext();
  const [values, handlers] = useListState(initialValues);

  const allChecked = values.every((value) => value.checked);
  const indeterminate = values.some((value) => value.checked) && !allChecked;

  useEffect(() => {
    const types = values.filter((value) => value.checked).map((value) => value.key);
    setSudsTypeFilter(types);
  }, [values]);

  const items = values.map((value, index) => (
    <Checkbox
      mt="xs"
      label={value.label}
      key={value.key}
      checked={value.checked}
      onChange={(event) => handlers.setItemProp(index, 'checked', event.currentTarget.checked)}
    />
  ));

  return (
    <>
      <Checkbox
        checked={allChecked}
        indeterminate={indeterminate}
        label="Show All"
        onChange={() =>
          handlers.setState((current) =>
            current.map((value) => ({ ...value, checked: !allChecked }))
          )
        }
      />
      {items}
    </>
  );
}
